import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import Broadcast_001 from './img/Broadcast_001.png'
import Broadcast_002 from './img/Broadcast_002.png'
import Broadcast_003 from './img/Broadcast_003.png'

export default class Broadcast extends Component {
  render() {
    return (
      <div className="main-window">
        <div className="main-window-title">直播</div>
        <div className="main-window-content">如果需要作为主播开始录制：</div>
        <div className="main-window-content">1、首次使用直播间功能需要下载直播软件并安装</div>
        <div className="main-window-content">2、设置好直播间名称、封面、公告信息</div>
        <div className="main-window-content">3、将服务器和串流密钥复制粘贴到 直播软件 {'>'} 设置 {'>'} 推流中，默认自定义服务</div>
        <div className="main-window-content">4、当推流开始，点击开始直播，即可作为主播使用直播功能</div>
        <div className="main-window-content">作为普通观众观看直播，只需打开直播界面即可</div>
        <img src={Broadcast_001} className="main-window-img"></img>
        <img src={Broadcast_002} className="main-window-img"></img>
        <img src={Broadcast_003} className="main-window-img"></img>
      </div>
    )
  }
}
